//==========import components===============
import Button from 'components/common/Button';

const AboutEvent = ({ data }) => {
  return (
    <section className='aboutEventSec DBlock py-10 sm:py-12 px-6 sm:px-10'>
      <div className='max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 relative z-1 md:px-12 md:pt-12'>
        <div className='fancyBorder hidden md:flex absolute top-0 left-0 h-40 w-40 -z-10'></div>
        <div>
          <h2 className='sm:text-lg text-base font-semibold text-eventLightYellow uppercase pb-2'>
            {data?.topTitle}
          </h2>
          <h1 className='sm:text-3xl text-lg xl:text-5xl uppercase font-bold'>
            {data?.title}
          </h1>
          <p className='text-sm lg:text-base font-light text-eventGray py-4 sm:py-6'>
            {data?.desc}
          </p>
          {data?.listing && (
            <ul className='flex items-center justify-start sm:justify-evenly font-semibold text-eventGray pb-10 sm:text-base text-xs flex-wrap gap-y-2 gap-x-4'>
              {data?.listing.map((list) => (
                <li key={`list${list?.id}`}>{list?.item}</li>
              ))}
            </ul>
          )}
          <Button url={data?.url} title={data?.btnText} />
        </div>
        <div className='justify-items-start'>
          <img src={data?.image} alt='evmImg' />
        </div>
      </div>
    </section>
  );
};

export default AboutEvent;
